export default __webpack_public_path__ + "static/media/diamonm_jubliee_logo.9ce07c1f.png";